import type { FC, ReactNode } from 'react'
import type { ContactTopic } from '@/constants/contact'
import type { TopicRequest } from '@/components/landing/contact'

import { useCallback, useState } from 'react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Hero } from '@/components/landing/hero'
import { Perks } from '@/components/landing/perks'
import { Clients } from '@/components/landing/clients'
import { Services } from '@/components/landing/services'
import { Benefits } from '@/components/landing/benefits'
import { Work } from '@/components/landing/work'
import { Process } from '@/components/landing/process'
import { Comparison } from '@/components/landing/comparison'
import { Testimonials } from '@/components/landing/testimonials'
import { Pricing } from '@/components/landing/pricing'
import { Team } from '@/components/landing/team'
import { Faq } from '@/components/landing/faq'
import { Contact } from '@/components/landing/contact'

const Home: FC = (): ReactNode => {
    const [topicRequest, setTopicRequest] = useState<TopicRequest | null>(null)

    // Buttons around the page (services, plans, hiring) preselect the topic
    // in the contact form. The id changes on every click so a repeat click
    // still updates the form.
    const requestTopic = useCallback((topic: ContactTopic): void => {
        setTopicRequest((current) => ({ topic, id: (current?.id ?? 0) + 1 }))
    }, [])

    return (
        <Layout>
            <Seo />

            <Hero />
            <Perks />
            <Clients />
            <Services onAsk={requestTopic} />
            <Benefits />
            <Work />
            <Process />
            <Comparison />
            <Testimonials />
            <Pricing onChoose={requestTopic} />
            <Team onApply={requestTopic} />
            <Faq />
            <Contact topicRequest={topicRequest} />
        </Layout>
    )
}

export default Home
